import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { isLocalhost } from "./environment";

const VISITOR_KEY = "egodziny_visitor_id";
const EXCLUDED_PREFIXES = ["/admin-panel", "/login", "/edit/"];

let lastTrackedPath = null;
let lastTrackedTime = 0;

const getVisitorId = () => {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = crypto.randomUUID
        ? crypto.randomUUID()
        : `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
};

export const trackPageView = (path) => {
  if (!path) return;
  if (isLocalhost()) return;
  if (EXCLUDED_PREFIXES.some((prefix) => path.startsWith(prefix))) return;

  const now = Date.now();
  if (path === lastTrackedPath && now - lastTrackedTime < 5000) return;
  lastTrackedPath = path;
  lastTrackedTime = now;

  const visitorId = getVisitorId();

  try {
    addDoc(collection(db, "page_views"), {
      path,
      visitorId,
      referrer: document.referrer || null,
      createdAt: serverTimestamp(),
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent || null,
    });
  } catch (error) {
    console.warn("Page view tracking failed.", error);
  }
};
